import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { I18nextProvider } from "react-i18next"
import { Flip, ToastContainer } from "react-toastify"

import * as serviceWorker from "./serviceWorker"
import { queryClient } from "./lib/queryClient"
import { AuthProvider } from "./contexts/AuthContext"
import { SelectedProjectProvider } from "./contexts/SelectedProjectContext"
import i18n from "./config/i18n"
import App from "./App"

// One-time cleanup of old redux-persist data
localStorage.removeItem("persist:root")

const container = document.getElementById("root")
if (!container) {
  throw new Error('Root element with id "root" was not found')
}

const root = createRoot(container)

root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <SelectedProjectProvider>
        <I18nextProvider i18n={i18n}>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            theme="light"
            transition={Flip}
            toastClassName="tw-text-dark tw-font-sans tw-rounded-xl tw-shadow-lg tw-px-4 tw-py-3"
          />
        </I18nextProvider>
      </SelectedProjectProvider>
    </AuthProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
  // </React.StrictMode>
)
serviceWorker.unregister()
